import { api } from "@/lib/axios";

export interface CreateTableData {
  number: string;
  capacity?: number;
  location?: string;
  active?: boolean;
}

export interface UpdateTableData {
  number?: string;
  capacity?: number;
  location?: string;
  active?: boolean;
}

export const tablesService = {
  create: async (data: CreateTableData) => {
    const response = await api.post("/tables", data);
    return response.data;
  },

  getAll: async (active?: boolean) => {
    const params = active !== undefined ? `?active=${active}` : "";
    const response = await api.get(`/tables${params}`);
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await api.get(`/tables/${id}`);
    return response.data;
  },

  update: async (id: string, data: UpdateTableData) => {
    const response = await api.patch(`/tables/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/tables/${id}`);
    return response.data;
  },

  getAvailable: async () => {
    const response = await api.get("/tables/available");
    return response.data;
  },

  getOccupied: async () => {
    const response = await api.get("/tables/occupied");
    return response.data;
  },
};
